module.exports = __webpack_public_path__ + "static/media/auditoriumLandscape.e3b0a3f7.jpg";